export default function EnterpriseCTA() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-teal-600 to-teal-700">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6">
            Prêt à Démarrer Votre Projet ?
          </h2>
          <p className="text-xl text-white/90 mb-10">
            Que vous ayez besoin d'un expert CVSE ou d'une entreprise générale, nous sommes là pour vous accompagner. Contactez-nous pour discuter de votre projet.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:info@casarenovaplus.ch"
              className="inline-flex items-center justify-center rounded-full bg-white px-8 py-4 text-base font-semibold text-teal-600 shadow-lg hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-xl mr-2"></i>
              Écrivez-nous
            </a>
            <a
              href="mailto:contact@votre-entreprise.ch"
              className="inline-flex items-center justify-center rounded-full bg-teal-500 px-8 py-4 text-base font-semibold text-white border-2 border-white/30 hover:bg-teal-400 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-xl mr-2"></i>
              Demander un Devis
            </a>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="text-white">
            <div className="text-4xl font-bold mb-2">19+</div>
            <div className="text-white/80">Années d'Expérience</div>
          </div>
          <div className="text-white">
            <div className="text-4xl font-bold mb-2">500+</div>
            <div className="text-white/80">Projets Réalisés</div>
          </div>
          <div className="text-white">
            <div className="text-4xl font-bold mb-2">100%</div>
            <div className="text-white/80">Clients Satisfaits</div>
          </div>
        </div>
      </div>
    </section>
  );
}
